export default __webpack_public_path__ + "static/media/NTE.2c9ff3b2.png";